import { makeStyles, createStyles, Theme } from "@material-ui/core";

export { useModuleListStyles };

const useModuleListStyles = makeStyles((theme: Theme) =>
	createStyles({
		moduleListWrapper: {
			flex: 1,
			overflow: "auto",
			overflowX: "hidden",
		},
		moduleList: {
			padding: 0,
		},
		moduleListItem: {
			color: theme.palette.secondary.dark,
			height: "46px",
		},
		moduleListItemSmall: {
			color: theme.palette.secondary.dark,
			height: "46px",
			padding: 0,
		},
		moduleListGroupedItem: {
			color: theme.palette.secondary.dark,
			paddingLeft: 40,
			height: "46px",
		},
		moduleListGroupedItemSmall: {
			color: theme.palette.secondary.dark,
			height: "46px",
		},
		iconPlaceholder: {
			color: "#000000",
			width: 26,
			marginRight: 13,
		},
		iconPlaceholderSmall: {
			color: "#000000",
			width: 26,
		},
		button: {
			justifyContent: "center",
			alignContent: "center",
			margin: 5,
		},
	})
);
